import { useEffect } from 'react';

/**
 * A safe redirect component that navigates via useEffect (not during render).
 * This avoids React warnings about state updates during render and ensures
 * the redirect happens reliably after the component mounts.
 */
const SafeRedirect = ({ to, history }) => {
  useEffect(() => {
    if (to) {
      history.replace(to);
    }
  }, [to, history]);
  return null;
};

export default SafeRedirect;
